/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DrugbankStrength
 */
export interface DrugbankStrength {
    /**
     * 
     * @type {string}
     * @memberof DrugbankStrength
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof DrugbankStrength
     */
    per?: string;
    /**
     * 
     * @type {string}
     * @memberof DrugbankStrength
     */
    units?: string;
    /**
     * 
     * @type {string}
     * @memberof DrugbankStrength
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof DrugbankStrength
     */
    unit?: string;
}

/**
 * Check if a given object implements the DrugbankStrength interface.
 */
export function instanceOfDrugbankStrength(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DrugbankStrengthFromJSON(json: any): DrugbankStrength {
    return DrugbankStrengthFromJSONTyped(json, false);
}

export function DrugbankStrengthFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrugbankStrength {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'per': !exists(json, 'per') ? undefined : json['per'],
        'units': !exists(json, 'units') ? undefined : json['units'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
    };
}

export function DrugbankStrengthToJSON(value?: DrugbankStrength | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'per': value.per,
        'units': value.units,
        'number': value.number,
        'unit': value.unit,
    };
}

